import React from "react";
import {
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  SvgIcon,
  useTheme,
} from "@mui/material";
import { Container, ListAvatar, StyledAvatar, StyledIconButton } from "./styles";
import MenuIcon from "@mui/icons-material/Menu";
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import PersonIcon from '@mui/icons-material/Person';
import { useNavigate } from "react-router-dom";
import { Client } from "@stomp/stompjs";
import { API_URL, links, sentActionLog, WEB_SOCKET_URL } from "../../utils/common";
import { Notification, NotificationResponse } from "../notificationCard/types";
import NotificationCard from "../notificationCard/notificationCard";

const NavBar: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [openNotification, setOpenNotification] = React.useState<boolean>(false);
  const [unreadNotifications, setUnreadNotifications] = React.useState<Notification[]>([]);
  const theme = useTheme();
  const navigate = useNavigate();
  const stompClientRef = React.useRef<Client | null>(null);

  const getUnreadNotifications = React.useCallback(() => {
    const token = localStorage.getItem("jwt");
    const user = localStorage.getItem("user");
    if (user){
      const userObject = JSON.parse(user);
      const userName = userObject['username'].split('@')[0]
      fetch(`${API_URL}/usuarios/notificaciones-pendientes?username=${userName}`, {
        method: "GET",
        headers: {
          Authorization: `bearer ${token}`,
          "content-type": "application/json",
        },
      })
      .then((res) => res.json())
      .then((response: NotificationResponse[]) => {
        if(response.length){
          setUnreadNotifications(response);
        } else {
          setUnreadNotifications([])
        }
      })
      .catch((err) => {
        console.error(err);
      });
    }
  },[]);

  const handleNavigate = (path: string, isExternal: boolean) => {
    sentActionLog('Click en link', `Usuario dio click en link ${isExternal ? 'externo' : ''  } ${path}`);
    if(isExternal){
      window.open(path, '_blank');
    } else {
      navigate(`/${path}`);
    }
  };

  React.useEffect(() => {
    const user = localStorage.getItem("user");
    if (user){
      const userObject = JSON.parse(user);
      const client = new Client({
        brokerURL: WEB_SOCKET_URL,
        reconnectDelay: 5000
      });
  
      client.onConnect = () => {
        client.publish({
          destination: "/app/register",
          body: JSON.stringify({
            correoUsuario: userObject.username
          }),
        });
        client.subscribe('/user/queue/notifications', message => {
          let notification = JSON.parse(message.body);
          setUnreadNotifications((old) => [notification, ...old]);
        });
        client.subscribe('/topic/notifications', message => {
          let notification = JSON.parse(message.body);
          setUnreadNotifications((old) => [notification, ...old]);
        });
      };
  
      client.activate();
      stompClientRef.current = client;
    }
  }, []);

  React.useEffect(() => {
    getUnreadNotifications()
  },[getUnreadNotifications])

  const DrawerList = () => {
    return (
      <Box role="presentation" onClick={() => setOpen(false)}>
        <List style={{ marginTop: 15 }} key="Links">
          {links.map((item) => (
            <>
              {item.shouldShow && 
              <>
                <ListItem key={item.path} disablePadding>
                  <ListItemButton onClick={() => handleNavigate(item.path, item.isExternal) } disabled={item.isDisabled}>
                    <ListItemAvatar sx={{ minWidth: "unset", marginRight: theme.spacing(.5)}}>
                      <ListAvatar theme={theme}>
                        <SvgIcon component={item.icon} />
                      </ListAvatar>
                    </ListItemAvatar>
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </ListItem>
                <Divider component="li" />
              </>}
            </>
          ))}
        </List>
      </Box>
    );
  };

  const renderNotifications = () => {
    return unreadNotifications.map((item) => <NotificationCard {...item} callback={getUnreadNotifications}  />)
  }

  return (
    <Container theme={theme}>
      <StyledAvatar theme={theme}>
        <PersonIcon/>
      </StyledAvatar>
      <Box ml="auto">
        <StyledIconButton theme={theme} aria-label="Notifications" onClick={() => setOpenNotification((old) => !old)}>
          <Badge badgeContent={unreadNotifications.length} color="primary">
            <NotificationsOutlinedIcon />
          </Badge>
        </StyledIconButton>
        <Dialog
          fullWidth={true}
          maxWidth="sm"
          open={openNotification}
          onClose={() => setOpenNotification(false)}
        >
          <DialogTitle>Notificaciones</DialogTitle>
          <DialogContent>
            {renderNotifications()}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenNotification(false)}>Cerrar</Button>
          </DialogActions>
        </Dialog>
        <StyledIconButton theme={theme}  aria-label="Menu" onClick={() => setOpen(true)}>
          <MenuIcon />
        </StyledIconButton>
      </Box>
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        {DrawerList()}
      </Drawer>
    </Container>
  );
};

export default NavBar;
